module.exports = __webpack_public_path__ + "static/ilustracao-controle-estoque-9855d47e2ff4a8d67246628945bee7a6.svg";